import * as reactIntl from 'react-intl';
import * as yup from 'yup';

export const processValidation = () => {
  const intl = reactIntl.useIntl();

  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  return yup.object().shape({
    validationCode: yup.string().required(requiredFieldMessage),
  });
};
